import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { SearchX, Home, Plus } from 'lucide-react'
import { Button, Card } from './ui'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <>
      <Helmet>
        <title>Page Not Found - YouWont</title>
        <meta name="description" content="The page you're looking for doesn't exist" />
      </Helmet>

      <div className="min-h-[60vh] flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md text-center animate-fade-in">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-slate-100 dark:bg-slate-800 mb-6">
            <SearchX size={36} className="text-slate-400 dark:text-slate-500" />
          </div>
          <h1 className="text-6xl font-bold text-slate-200 dark:text-slate-700 mb-2 leading-none">404</h1>
          <h2 className="text-2xl font-bold text-slate-900 dark:text-slate-100 mb-3">Well, This is Awkward.</h2>
          <p className="text-slate-500 dark:text-slate-400 mb-8 leading-relaxed">
            Whatever you were looking for took one look at this URL and noped out. Honestly, same.
          </p>
          <Card className="text-left">
            <div className="flex flex-col gap-3">
              <Button variant="primary" size="lg" className="w-full" onClick={() => navigate('/')}>
                <Home size={16} className="mr-2" />
                Take Me Home
              </Button>
              <Button variant="secondary" size="lg" className="w-full" onClick={() => navigate('/setup')}>
                <Plus size={16} className="mr-2" />
                Make Something Scannable
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}

export default NotFound
